import { gql } from '@apollo/client';

export const SEARCH_TRACKING_CLICK = gql`
    mutation SearchTrackingClick($trackingClickPos: TrackingClickPos!) {
        searchTrackingClick(trackingClickPos: $trackingClickPos)
    }
`;
